import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'

import { ButtonGroupDirective } from './button-group.directive'
import { ConfirmClickDirective } from './confirm-click.directive'
import { ConsoleViewOnlyDirective } from './console-view-only.directive'
import { AppDropdownDirective } from './dropdown.directive'
import { DropdownAnchorDirective } from './dropdown-anchor.directive'
import { DropdownLinkDirective } from './dropdown-link.directive'
import { EmbeddedViewOnlyDirective } from './embedded-view-only.directive'
import { HasAccessDirective } from './has-access.directive'
import { HasIntegrationSupportDirective } from './has-integration-support.directive'
import { HasModuleDirective } from './has-module.directive'
import { HasPermissionDirective } from './has-permission.directive'
import { TrimValueAccessorDirective } from './trim-value-accessor'

@NgModule({
  imports: [CommonModule],
  declarations: [
    AppDropdownDirective,
    ButtonGroupDirective,
    ConfirmClickDirective,
    ConsoleViewOnlyDirective,
    DropdownAnchorDirective,
    DropdownLinkDirective,
    EmbeddedViewOnlyDirective,
    TrimValueAccessorDirective,
    HasAccessDirective,
    HasPermissionDirective,
    HasIntegrationSupportDirective,
    HasModuleDirective,
  ],
  exports: [
    AppDropdownDirective,
    ConsoleViewOnlyDirective,
    ButtonGroupDirective,
    ConfirmClickDirective,
    DropdownAnchorDirective,
    DropdownLinkDirective,
    EmbeddedViewOnlyDirective,
    TrimValueAccessorDirective,
    HasAccessDirective,
    HasPermissionDirective,
    HasIntegrationSupportDirective,
    HasModuleDirective,
  ],
})
export class DirectivesModule {}
